import { render, staticRenderFns } from "./RelateBillableItemsDialog.vue?vue&type=template&id=a3c3b5dc&scoped=true&"
import script from "./RelateBillableItemsDialog.vue?vue&type=script&lang=js&"
export * from "./RelateBillableItemsDialog.vue?vue&type=script&lang=js&"
import style0 from "./RelateBillableItemsDialog.vue?vue&type=style&index=0&id=a3c3b5dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c3b5dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VSelect})
